function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsuranceSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC9FF"
    },
    d: "M478.838,109.5c-5.863-4.408-13.464-5.793-20.505-3.739c-12.923,3.77-26.103,5.682-39.179,5.682 c-37.537,0-74.71-10.997-101.984-30.169c-24.086-16.93-37.897-38.071-37.897-58C279.273,10.42,268.853,0,256,0 c-7.23,0-13.689,3.297-17.959,8.47c-1.898,2.299-3.362,4.968-4.268,7.883c-0.68,2.185-1.046,4.51-1.046,6.92 c0,19.929-13.812,41.07-37.897,58c-1.705,1.198-3.447,2.365-5.227,3.499c-26.695,17.006-61.566,26.671-96.757,26.671 c-13.078,0-26.258-1.911-39.177-5.682c-1.761-0.514-3.556-0.813-5.35-0.903c-5.384-0.27-10.758,1.336-15.157,4.642 c-5.131,3.859-8.406,9.635-9.134,15.934c-0.104,0.9-0.155,1.811-0.154,2.728c0.088,34.81,4.454,67.531,11.405,97.632 c0.773,3.345,1.576,6.658,2.411,9.936c5.837,22.955,13.124,44.288,21.066,63.75c1.134,2.78,2.282,5.522,3.441,8.226 c2.318,5.407,4.679,10.657,7.067,15.746c1.193,2.544,2.394,5.049,3.598,7.512c13.245,27.093,26.981,49.209,38.116,65.376 c1.417,2.056,2.842,4.094,4.279,6.113c1.437,2.018,2.883,4.022,4.34,6.003c4.368,5.947,8.819,11.722,13.335,17.303 c1.505,1.86,3.018,3.7,4.538,5.517c3.038,3.634,6.104,7.18,9.19,10.631c4.63,5.176,9.306,10.141,14.012,14.871 c7.843,7.885,15.766,15.121,23.689,21.617c4.088,3.353,8.605,6.848,13.43,10.262c0.689,0.487,1.385,0.973,2.087,1.457 c1.403,0.968,2.83,1.925,4.278,2.869C220.084,503.363,238.576,512,256,512c25.342,0,52.945-18.274,71.638-33.604 c25.349-20.789,50.722-49.163,73.38-82.057c32.396-47.031,86.792-144.413,87.107-268.179 C488.142,120.824,484.701,113.909,478.838,109.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDFDFF"
    },
    d: "M167.633,349.378H256V261.01C207.197,261.01,167.633,300.57,167.633,349.378z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDFDFF"
    },
    d: "M344.367,349.378c0-48.808-39.564-88.368-88.367-88.368v88.368H344.367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDFDFF"
    },
    d: "M312.809,204.201c0-31.375-25.436-56.807-56.809-56.807V261.01 C287.373,261.01,312.809,235.576,312.809,204.201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDFDFF"
    },
    d: "M199.191,204.201c0,31.375,25.437,56.807,56.809,56.807V147.394 C224.627,147.394,199.191,172.826,199.191,204.201z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#57A4FF"
    },
    d: "M167.633,349.378c0-48.808,39.564-88.368,88.367-88.368c-31.373,0-56.809-25.434-56.809-56.807 c0-31.376,25.436-56.809,56.809-56.809V0c-12.853,0-23.273,10.42-23.273,23.273c0,19.929-13.812,41.07-37.897,58 c-27.274,19.172-64.447,30.169-101.984,30.169c-13.078,0-26.258-1.911-39.177-5.682c-7.041-2.054-14.643-0.67-20.506,3.739 c-5.863,4.409-9.304,11.325-9.286,18.66c0.313,123.766,54.71,221.147,87.105,268.179c22.658,32.894,48.032,61.268,73.38,82.057 C203.053,493.726,230.656,512,256,512V349.378H167.633z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsuranceSvgrepoCom);
export default __webpack_public_path__ + "static/media/insurance-svgrepo-com.f0340937928189fdd766efc171121648.svg";
export { ForwardRef as ReactComponent };